var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"track"},[_vm._t("default")],2),_vm._v(" "),_vm._t("below-track",null,{next:_vm.next,previous:_vm.previous})],2)}
var staticRenderFns = []

export { render, staticRenderFns }